export const detailPromo = {
  path: "/detail_promo",
  name: "detailPromo",
  hidden: true,
  component: () => import("@/components/promo/components/detailPromo"),
  meta: {
    title: "Detail Promo",
    icon: "fa-area-chart",
    roles: ["pasien"]
  }
};
export default detailPromo;



// WEBPACK FOOTER //
// ./src/router/modules/detailpromo.js